import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvPillComponent } from './nv-pill.component';
import { NvAriaLabelModule } from '../directives/nv-aria-label/nv-aria-label.module';

@NgModule({
  imports: [CommonModule, NvIconModule, NvAriaLabelModule],
  declarations: [NvPillComponent],
  exports: [NvPillComponent],
})
export class NvPillModule {}
